import Vue from 'vue'
import Vuex from 'vuex'
import createMutationsSharer from "vuex-shared-mutations";

Vue.use(Vuex)

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/)

const modules = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
  )
  .reduce((modules, [name, module]) => {
    if (module.namespaced === undefined) {
      module.namespaced = true
    }

    return { ...modules, [name]: module }
  }, {})

export default new Vuex.Store({
  modules,
  plugins: [
    createMutationsSharer({
      predicate: (mutation, state) => {
        if (mutation.type.startsWith('route/') || 
            mutation.type.startsWith('cirt/') ||
            mutation.type === 'teacherClass/SET_VM' ||
            mutation.type === 'teacherClass/SET_PAGE_MODE' ||
            mutation.type === 'survey/SET_SURVEYS' ||
            mutation.type === 'chat/INIT_CHAT' ||
            mutation.type === 'chat/OPEN_BUBBLE_CHAT' ||
            mutation.type === 'chat/CLOSE_BUBBLE_CHAT' ||
            mutation.type === 'chat/POPULATE_CHAT_FROM_DB' ||
            (mutation.type === 'chat/ADD_MESSAGE' && mutation.payload.receiving)) {
          return false
        }
        return true
      }
    })
  ]
})
